import { useCallback, useMemo } from "react";
import { useLivePreview } from "@payloadcms/live-preview-react";
import { getPayloadCmsUrl } from "src/api/payload/client";
import { mapPromotion } from "src/utils/mapPromotion";
import { promotionsLivePreviewRequestHandler } from "src/utils/promotionsLivePreviewHandler";
import { isPayloadPromotionsSource } from "src/utils/promotionsSource";

/**
 * Live preview for a single promotion card (admin iframe on /promotions/preview).
 *
 * @param {string} [locale] - `en` | `fr`
 */
export function usePromotionCardLivePreview(locale) {
  const enabled = isPayloadPromotionsSource();
  const initialDoc = useMemo(() => ({}), []);
  const requestHandler = useCallback(promotionsLivePreviewRequestHandler, []);

  const { data: liveDoc, isLoading } = useLivePreview({
    initialData: initialDoc,
    serverURL: getPayloadCmsUrl(),
    depth: 0,
    requestHandler,
  });

  const card = useMemo(() => {
    if (!enabled || !liveDoc?.key) return null;
    return mapPromotion(liveDoc, locale);
  }, [enabled, liveDoc, locale]);

  return {
    card,
    isLoading: enabled && isLoading,
    isLivePreview: Boolean(liveDoc?.key),
  };
}
